import { Form, Input, Select, Button } from "antd";
import { ToastService } from "@shared/lib/services";
import {
  IBriefInvoice,
  INVOICE_SUB_TYPE,
  INVOICE_TYPE,
} from "@shared/lib/types/briefInvoice";
import { InputNumber } from "@shared/ui/InputNumber";

const { Option } = Select;

interface EditBriefInvoiceEntryProps {
  onSubmit: (values: any) => void;
  isSubmitting: boolean;
  onCancel: () => void;
  initialValues: IBriefInvoice;
}

export function EditBriefInvoiceEntry({
  onSubmit,
  isSubmitting,
  onCancel,
  initialValues,
}: EditBriefInvoiceEntryProps) {
  const [form] = Form.useForm();

  const handleSubmit = (values: any) => {
    onSubmit({
      ...values,
      brandInvoiceId: initialValues._id,
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={{
        invoiceNumber: initialValues.invoiceNumber,
        type: initialValues.type,
        subType: initialValues.subType,
        baseAmount: initialValues.baseAmount,
        gstAmount: initialValues.gstAmount,
        url: initialValues.url,
      }}
      onFinishFailed={({ errorFields }) => {
        if (errorFields.length) {
          ToastService.error(
            "Error Submitting Form. Please fill all required fields."
          );
        }
      }}
    >
      <Form.Item name="invoiceNumber" label="Invoice Number">
        <Input placeholder="Enter Invoice Number" />
      </Form.Item>
      <Form.Item
        name="url"
        label="URL"
        rules={[{ type: "url", message: "Please enter a valid URL" }]}
      >
        <Input placeholder="Enter URL" />
      </Form.Item>

      <Form.Item
        name="type"
        label="Type"
        rules={[{ required: true, message: "Type is required" }]}
      >
        <Select placeholder="Select Type">
          {Object.values(INVOICE_TYPE).map((type) => (
            <Option key={type} value={type}>
              {type}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="subType"
        label="Sub Type"
        rules={[{ required: true, message: "Sub Type is required" }]}
      >
        <Select placeholder="Select Type">
          {Object.values(INVOICE_SUB_TYPE).map((type) => (
            <Option key={type} value={type}>
              {type}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="baseAmount"
        label="Base Amount"
        rules={[{ required: true, message: "Base Amount is required" }]}
      >
        <InputNumber
          type="number"
          style={{ width: "100%" }}
          placeholder="Enter Base Amount"
          min={0}
        />
      </Form.Item>
      <Form.Item
        name="gstAmount"
        label="Gst Amount"
        rules={[{ required: true, message: "GSt Amount is required" }]}
      >
        <InputNumber
          type="number"
          style={{ width: "100%" }}
          placeholder="Enter Gst Amount"
          min={0}
        />
      </Form.Item>

      <Form.Item>
        <div
          style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}
        >
          <Button onClick={onCancel}>Cancel</Button>
          <Button
            type="primary"
            htmlType="submit"
            disabled={isSubmitting}
            loading={isSubmitting}
          >
            {isSubmitting ? "Updating..." : "Update"}
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
}
